import { Controller } from "@hotwired/stimulus"
import { renderSection } from "../magic_sheep/art"

// Mounts a page's Magic Sheep art (parametric SVG generated by magic_sheep/art.jsx)
// into its element. Usage in HAML:  %div{ data: { controller: "art", art_section_value: "flock" } }
export default class extends Controller {
  static values = { section: String }

  connect() {
    this.element.innerHTML = renderSection(this.sectionValue)
  }
}
